module.exports = __webpack_public_path__ + "media/klaseaDia1Barco3Vertical.06fadb70.mp4";